export enum UserRole {
  admin = 'admin',
  traveler = 'traveler',
  shopper = 'shopper'
}
